/**
 * @generated SignedSource<<b8ed8eaef4b700d33db89b10913ff41c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AutomationBranchFilterOperator = "AND" | "OR" | "%future added value";
export type AutomationFilterConditionEntity = "audience_member" | "member_group" | "profile_field" | "trigger" | "%future added value";
export type AutomationFilterConditionRule = "contains_all" | "contains_any" | "contains_string" | "guest_memberships" | "is_empty" | "is_exactly" | "is_not_empty" | "is_not_exactly" | "is_trigger_user" | "matches_regex" | "not_contains_all" | "not_contains_any" | "not_contains_string" | "organization_memberships" | "%future added value";
export type AutomationFilterLevel = "branch" | "step" | "trigger" | "%future added value";
export type AutomationKind = "custom" | "default" | "system" | "%future added value";
export type AutomationStatus = "draft" | "published" | "%future added value";
export type AutomationStepActionKind = "add_to_group" | "add_to_pathway" | "add_to_product" | "add_to_slack_channel" | "release_certificate" | "remove_from_group" | "remove_from_pathway" | "remove_from_product" | "remove_from_slack_channel" | "send_chat_channel_message" | "send_chat_direct_message" | "send_email" | "send_slack_direct_message" | "%future added value";
export type AutomationStepKind = "action" | "branch" | "delay" | "%future added value";
export type AutomationStepWarningKind = "slack_channel_removed" | "%future added value";
export type AutomationTemplateKind = "custom" | "product_completion" | "welcome_to_community" | "welcome_to_course" | "%future added value";
export type AutomationTriggerKind = "member_completed_pathway" | "member_completed_product" | "member_event_rsvp" | "member_joined_community" | "member_joined_course" | "member_joined_event" | "member_joined_group" | "member_joined_pathway" | "member_leaving_community" | "member_left_course" | "member_left_pathway" | "member_onboarding_completed" | "member_removed_group" | "module_completed" | "product_ended" | "profile_field_changed" | "scheduled" | "%future added value";
export type MessageTemplateKind = "community_welcome" | "course_welcome" | "custom" | "product_completion" | "%future added value";
export type UpdateAutomationInput = {
  automationId?: string | null;
  createdWithTemplate?: AutomationTemplateKind | null;
  dismissWarnings?: boolean | null;
  name?: string | null;
  organizationId: string;
  status?: AutomationStatus | null;
  steps?: ReadonlyArray<UpdateAutomationStepInput> | null;
  trigger?: UpdateAutomationTriggerInput | null;
};
export type UpdateAutomationTriggerInput = {
  id?: string | null;
  kind?: AutomationTriggerKind | null;
  metadata?: AutomationTriggerMetadataInput | null;
  schedule?: UpdateAutomationTriggerScheduleInput | null;
};
export type AutomationTriggerMetadataInput = {
  memberGroupIds?: ReadonlyArray<string> | null;
  moduleIds?: ReadonlyArray<string> | null;
  occurrenceIds?: ReadonlyArray<string> | null;
  productIds?: ReadonlyArray<string> | null;
  profileField?: AutomationTriggerProfileFieldMetadataInput | null;
};
export type AutomationTriggerProfileFieldMetadataInput = {
  id: string;
  optionIds?: ReadonlyArray<string> | null;
  value?: string | null;
};
export type UpdateAutomationTriggerScheduleInput = {
  id?: string | null;
  triggerAt: string;
};
export type UpdateAutomationStepInput = {
  actionKind?: AutomationStepActionKind | null;
  branches?: ReadonlyArray<UpdateAutomationBranchInput> | null;
  certificateTemplateId?: string | null;
  channels?: ReadonlyArray<string> | null;
  delay?: string | null;
  filters?: ReadonlyArray<UpdateAutomationFilterInput> | null;
  id?: string | null;
  kind: AutomationStepKind;
  memberGroupIds?: ReadonlyArray<string> | null;
  messageTemplate?: MessageTemplateInput | null;
  productIds?: ReadonlyArray<string> | null;
};
export type UpdateAutomationFilterInput = {
  condition: FilterCondition;
  id?: string | null;
  level: AutomationFilterLevel;
};
export type FilterCondition = {
  entity: AutomationFilterConditionEntity;
  entityId?: string | null;
  organizationMembershipIds?: ReadonlyArray<string> | null;
  rule: AutomationFilterConditionRule;
  value?: string | null;
  values?: ReadonlyArray<string> | null;
};
export type MessageTemplateInput = {
  chatContent?: ChatContentInput | null;
  emailContent?: EmailContentInput | null;
  id?: string | null;
  kind?: MessageTemplateKind | null;
  name: string;
  slackContent?: SlackContentInput | null;
};
export type EmailContentInput = {
  bccEmails?: ReadonlyArray<string> | null;
  bccUserIds?: ReadonlyArray<string> | null;
  ccEmails?: ReadonlyArray<string> | null;
  ccUserIds?: ReadonlyArray<string> | null;
  richBody: string;
  send: boolean;
  subject: string;
};
export type SlackContentInput = {
  richBody: string;
  send: boolean;
  sendAs?: string | null;
};
export type ChatContentInput = {
  richBody: string;
  send: boolean;
  sendAs?: string | null;
};
export type UpdateAutomationBranchInput = {
  color?: string | null;
  filterOperator: AutomationBranchFilterOperator;
  filters: ReadonlyArray<UpdateAutomationFilterInput>;
  id?: string | null;
  name: string;
  steps: ReadonlyArray<UpdateAutomationStepInput>;
};
export type AutomationDrawerContentMutation$variables = {
  input: UpdateAutomationInput;
};
export type AutomationDrawerContentMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
      readonly kind: AutomationKind;
      readonly name: string;
      readonly status: AutomationStatus;
      readonly steps: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly actionChannels: ReadonlyArray<string> | null;
            readonly actionKind: AutomationStepActionKind | null;
            readonly actionMemberGroupIds: ReadonlyArray<string> | null;
            readonly actionMessageTemplate: {
              readonly chatContent: {
                readonly richBody: string;
                readonly send: boolean;
                readonly sendAs: string | null;
              } | null;
              readonly emailContent: {
                readonly bccEmails: ReadonlyArray<string> | null;
                readonly bccUserIds: ReadonlyArray<string> | null;
                readonly ccEmails: ReadonlyArray<string> | null;
                readonly ccUserIds: ReadonlyArray<string> | null;
                readonly richBody: string;
                readonly send: boolean;
                readonly subject: string;
              } | null;
              readonly id: string;
              readonly kind: MessageTemplateKind | null;
              readonly name: string;
              readonly slackContent: {
                readonly richBody: string;
                readonly send: boolean;
                readonly sendAs: string | null;
              } | null;
            } | null;
            readonly actionProductIds: ReadonlyArray<string> | null;
            readonly branches: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly color: string;
                  readonly filterOperator: AutomationBranchFilterOperator;
                  readonly filters: {
                    readonly edges: ReadonlyArray<{
                      readonly node: {
                        readonly condition: string;
                        readonly id: string;
                        readonly level: AutomationFilterLevel;
                      };
                    }>;
                  };
                  readonly id: string;
                  readonly name: string;
                  readonly steps: {
                    readonly edges: ReadonlyArray<{
                      readonly node: {
                        readonly actionChannels: ReadonlyArray<string> | null;
                        readonly actionKind: AutomationStepActionKind | null;
                        readonly actionMemberGroupIds: ReadonlyArray<string> | null;
                        readonly actionMessageTemplate: {
                          readonly chatContent: {
                            readonly richBody: string;
                            readonly send: boolean;
                            readonly sendAs: string | null;
                          } | null;
                          readonly emailContent: {
                            readonly bccEmails: ReadonlyArray<string> | null;
                            readonly bccUserIds: ReadonlyArray<string> | null;
                            readonly ccEmails: ReadonlyArray<string> | null;
                            readonly ccUserIds: ReadonlyArray<string> | null;
                            readonly richBody: string;
                            readonly send: boolean;
                            readonly subject: string;
                          } | null;
                          readonly id: string;
                          readonly kind: MessageTemplateKind | null;
                          readonly name: string;
                          readonly slackContent: {
                            readonly richBody: string;
                            readonly send: boolean;
                            readonly sendAs: string | null;
                          } | null;
                        } | null;
                        readonly actionProductIds: ReadonlyArray<string> | null;
                        readonly delay: string | null;
                        readonly filters: {
                          readonly edges: ReadonlyArray<{
                            readonly node: {
                              readonly condition: string;
                              readonly id: string;
                              readonly level: AutomationFilterLevel;
                            };
                          }>;
                        } | null;
                        readonly id: string;
                        readonly kind: AutomationStepKind;
                        readonly warningKind: AutomationStepWarningKind | null;
                      };
                    }>;
                  };
                };
              }>;
            };
            readonly delay: string | null;
            readonly filters: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly condition: string;
                  readonly id: string;
                  readonly level: AutomationFilterLevel;
                };
              }>;
            } | null;
            readonly id: string;
            readonly kind: AutomationStepKind;
            readonly warningKind: AutomationStepWarningKind | null;
          };
        }>;
        readonly totalCount: number;
      } | null;
      readonly triggers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly kind: AutomationTriggerKind;
            readonly metadata: {
              readonly memberGroupIds: ReadonlyArray<string> | null;
              readonly moduleIds: ReadonlyArray<string> | null;
              readonly occurrenceIds: ReadonlyArray<string> | null;
              readonly productIds: ReadonlyArray<string> | null;
              readonly profileField: {
                readonly id: string;
                readonly optionIds: ReadonlyArray<string> | null;
                readonly value: string | null;
              } | null;
            } | null;
            readonly schedule: {
              readonly id: string;
              readonly triggerAt: string | null;
            } | null;
          };
        }>;
      };
      readonly " $fragmentSpreads": FragmentRefs<"AutomationDrawerHeaderFragment" | "AutomationDrawerSubmitButtonFragment" | "AutomationsReportsTableRow_Automation">;
    } | null;
  };
};
export type AutomationDrawerContentMutation = {
  response: AutomationDrawerContentMutation$data;
  variables: AutomationDrawerContentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "AutomationTriggerNodeConnection",
  "kind": "LinkedField",
  "name": "triggers",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AutomationTriggerNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AutomationTrigger",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "AutomationTriggerMetadata",
              "kind": "LinkedField",
              "name": "metadata",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "moduleIds",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "productIds",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AutomationTriggerProfileFieldMetadata",
                  "kind": "LinkedField",
                  "name": "profileField",
                  "plural": false,
                  "selections": [
                    (v2/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "value",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "optionIds",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "occurrenceIds",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "memberGroupIds",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": "schedule",
              "args": null,
              "concreteType": "AutomationTriggerSchedule",
              "kind": "LinkedField",
              "name": "automationTriggerSchedule",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "triggerAt",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actionKind",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "delay",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actionMemberGroupIds",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actionChannels",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actionProductIds",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "warningKind",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "AutomationFilterNodeConnection",
  "kind": "LinkedField",
  "name": "filters",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AutomationFilterNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AutomationFilter",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "level",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "condition",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "send",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "richBody",
  "storageKey": null
},
v17 = [
  (v15/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sendAs",
    "storageKey": null
  },
  (v16/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "MessageTemplate",
  "kind": "LinkedField",
  "name": "actionMessageTemplate",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MessageTemplateEmailContent",
      "kind": "LinkedField",
      "name": "emailContent",
      "plural": false,
      "selections": [
        (v15/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subject",
          "storageKey": null
        },
        (v16/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ccEmails",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bccEmails",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ccUserIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bccUserIds",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MessageTemplateSlackContent",
      "kind": "LinkedField",
      "name": "slackContent",
      "plural": false,
      "selections": (v17/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MessageTemplateChatContent",
      "kind": "LinkedField",
      "name": "chatContent",
      "plural": false,
      "selections": (v17/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "AutomationStepNodeConnection",
  "kind": "LinkedField",
  "name": "steps",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AutomationStepNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AutomationStep",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v5/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/),
            (v18/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "AutomationBranchNodeConnection",
              "kind": "LinkedField",
              "name": "branches",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AutomationBranchNodeEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AutomationBranch",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v2/*: any*/),
                        (v4/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "color",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "filterOperator",
                          "storageKey": null
                        },
                        (v14/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AutomationStepNodeConnection",
                          "kind": "LinkedField",
                          "name": "steps",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "AutomationStepNodeEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "AutomationStep",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    (v2/*: any*/),
                                    (v5/*: any*/),
                                    (v8/*: any*/),
                                    (v9/*: any*/),
                                    (v10/*: any*/),
                                    (v11/*: any*/),
                                    (v12/*: any*/),
                                    (v13/*: any*/),
                                    (v14/*: any*/),
                                    (v18/*: any*/)
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = [
  (v2/*: any*/),
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AutomationDrawerContentMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "UpdateAutomationResponse",
        "kind": "LinkedField",
        "name": "updateAutomation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Automation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AutomationDrawerHeaderFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AutomationDrawerSubmitButtonFragment"
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AutomationsReportsTableRow_Automation"
              },
              (v6/*: any*/),
              (v19/*: any*/)
            ],
            "storageKey": null
          },
          (v20/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AutomationDrawerContentMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "UpdateAutomationResponse",
        "kind": "LinkedField",
        "name": "updateAutomation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Automation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requiresReview",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AutomationExecuton",
                "kind": "LinkedField",
                "name": "mostRecentlyCompletedExecution",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "completedAt",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentNodeConnection",
                "kind": "LinkedField",
                "name": "targetedModules",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v21/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductNodeConnection",
                "kind": "LinkedField",
                "name": "targetedProducts",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v21/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OccurrenceNodeConnection",
                "kind": "LinkedField",
                "name": "targetedOccurrences",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OccurrenceNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Occurrence",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v21/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberGroupNodeConnection",
                "kind": "LinkedField",
                "name": "targetedMemberGroups",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberGroupNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v21/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v19/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v20/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c62b73d9c28a0a6da8f59737ef9fdcd9",
    "id": null,
    "metadata": {},
    "name": "AutomationDrawerContentMutation",
    "operationKind": "mutation",
    "text": "mutation AutomationDrawerContentMutation(\n  $input: UpdateAutomationInput!\n) {\n  response: updateAutomation(input: $input) {\n    node {\n      id\n      ...AutomationDrawerHeaderFragment\n      ...AutomationDrawerSubmitButtonFragment\n      status\n      name\n      kind\n      ...AutomationsReportsTableRow_Automation\n      triggers {\n        edges {\n          node {\n            id\n            kind\n            metadata {\n              moduleIds\n              productIds\n              profileField {\n                id\n                value\n                optionIds\n              }\n              occurrenceIds\n              memberGroupIds\n            }\n            schedule: automationTriggerSchedule {\n              id\n              triggerAt\n            }\n          }\n        }\n      }\n      steps {\n        totalCount\n        edges {\n          node {\n            id\n            kind\n            actionKind\n            delay\n            actionMemberGroupIds\n            actionChannels\n            actionProductIds\n            warningKind\n            filters {\n              edges {\n                node {\n                  id\n                  level\n                  condition\n                }\n              }\n            }\n            actionMessageTemplate {\n              id\n              name\n              kind\n              emailContent {\n                send\n                subject\n                richBody\n                ccEmails\n                bccEmails\n                ccUserIds\n                bccUserIds\n              }\n              slackContent {\n                send\n                sendAs\n                richBody\n              }\n              chatContent {\n                send\n                sendAs\n                richBody\n              }\n            }\n            branches {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                  filterOperator\n                  filters {\n                    edges {\n                      node {\n                        id\n                        level\n                        condition\n                      }\n                    }\n                  }\n                  steps {\n                    edges {\n                      node {\n                        id\n                        kind\n                        actionKind\n                        delay\n                        actionMemberGroupIds\n                        actionChannels\n                        actionProductIds\n                        warningKind\n                        filters {\n                          edges {\n                            node {\n                              id\n                              level\n                              condition\n                            }\n                          }\n                        }\n                        actionMessageTemplate {\n                          id\n                          name\n                          kind\n                          emailContent {\n                            send\n                            subject\n                            richBody\n                            ccEmails\n                            bccEmails\n                            ccUserIds\n                            bccUserIds\n                          }\n                          slackContent {\n                            send\n                            sendAs\n                            richBody\n                          }\n                          chatContent {\n                            send\n                            sendAs\n                            richBody\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment AutomationDrawerHeaderFragment on Automation {\n  status\n}\n\nfragment AutomationDrawerSubmitButtonFragment on Automation {\n  status\n}\n\nfragment AutomationsReportsTableRow_Automation on Automation {\n  id\n  name\n  status\n  requiresReview\n  mostRecentlyCompletedExecution {\n    completedAt\n    id\n  }\n  targetedModules {\n    totalCount\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  targetedProducts {\n    totalCount\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  targetedOccurrences {\n    totalCount\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  targetedMemberGroups {\n    totalCount\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  steps {\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "c82c0f6d6a9177996970d2fb7116a0aa";

export default node;
